export function isBeforePromoExpiry(): boolean {
  // Promotion expires at 11:59 PM PDT (UTC-7) on May 26, 2025
  const expiryDate = new Date('2025-05-27T06:59:59Z'); // 2025-05-27T06:59:59Z -> 11:59 PM PDT = 06:59:59 UTC next day
  return new Date() < expiryDate;
}
